
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Passengers() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const flightNumber = searchParams.get('flight') || 'SV123';
  
  const [filterGender, setFilterGender] = useState('all');
  const [passengers] = useState([
    {
      id: 1,
      name: 'سارة أحمد',
      shortName: 'س.أ',
      avatar: 'https://public.readdy.ai/ai/img_res/ef6ac36bd710ff4f8292abd1ef59fa4b.jpg',
      bio: 'مسافرة سياحية - الرياض إلى دبي',
      gender: 'female',
      isOnline: true,
      country: 'السعودية',
      destination: 'دبي',
      showContact: true
    },
    {
      id: 2,
      name: 'محمد علي',
      shortName: 'م.ع',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20man%20portrait%2C%20business%20attire%2C%20confident%20smile%2C%20clean%20background%2C%20high%20quality%20headshot%2C%20modern%20lighting&width=100&height=100&seq=2&orientation=squarish',
      bio: 'رجل أعمال - الرياض إلى دبي',
      gender: 'male',
      isOnline: false,
      country: 'السعودية',
      destination: 'دبي',
      showContact: false
    },
    {
      id: 3,
      name: 'فاطمة محمد',
      shortName: 'ف.م',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%2C%20hijab%2C%20friendly%20expression%2C%20clean%20background%2C%20high%20quality%20headshot%2C%20modern%20lighting&width=100&height=100&seq=3&orientation=squarish',
      bio: 'طالبة جامعية - الرياض إلى دبي',
      gender: 'female',
      isOnline: true,
      country: 'السعودية',
      destination: 'دبي',
      showContact: true
    },
    {
      id: 4,
      name: 'عبدالله سالم',
      shortName: 'ع.س',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20man%20portrait%2C%20traditional%20dress%2C%20warm%20smile%2C%20clean%20background%2C%20high%20quality%20headshot%2C%20modern%20lighting&width=100&height=100&seq=4&orientation=squarish',
      bio: 'مهندس - الرياض إلى دبي',
      gender: 'male',
      isOnline: true,
      country: 'السعودية',
      destination: 'دبي',
      showContact: true
    }
  ]);

  const filteredPassengers = passengers.filter(passenger => 
    filterGender === 'all' || passenger.gender === filterGender
  );

  const handleChatRequest = (passenger: any) => {
    // Navigate to passenger profile or send chat request
    navigate(`/passenger-profile/${passenger.id}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 pt-12 pb-6 px-6">
        <div className="flex items-center justify-between mb-4">
          <button 
            onClick={() => navigate('/main')}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center"
          >
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          
          <h1 className="text-xl font-bold text-white font-arabic">ركاب الرحلة {flightNumber}</h1>
          
          <button className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-search-line text-white text-lg"></i>
          </button>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-white/80 text-sm font-arabic">إجمالي الركاب</p>
              <p className="text-2xl font-bold">{passengers.length}</p>
            </div>
            <div>
              <p className="text-white/80 text-sm font-arabic">متصل الآن</p>
              <p className="text-2xl font-bold">{passengers.filter(p => p.isOnline).length}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="px-6 py-4">
        <div className="flex space-x-3 space-x-reverse">
          <button
            onClick={() => setFilterGender('all')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 font-arabic ${
              filterGender === 'all'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-600 border border-gray-200'
            }`}
          >
            الكل
          </button>
          <button
            onClick={() => setFilterGender('male')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 font-arabic ${
              filterGender === 'male'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-600 border border-gray-200'
            }`}
          >
            رجال
          </button>
          <button
            onClick={() => setFilterGender('female')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 font-arabic ${
              filterGender === 'female'
                ? 'bg-blue-500 text-white'
                : 'bg-white text-gray-600 border border-gray-200'
            }`}
          >
            نساء
          </button>
        </div>
      </div>

      {/* Passengers List */}
      <div className="px-6 space-y-4">
        {filteredPassengers.map((passenger) => (
          <div key={passenger.id} className="bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="flex items-center space-x-4 space-x-reverse">
              {/* Avatar */}
              <div className="relative">
                <img
                  src={passenger.avatar}
                  alt={passenger.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div className={`absolute bottom-0 right-0 w-5 h-5 rounded-full border-2 border-white ${
                  passenger.isOnline ? 'bg-green-500' : 'bg-gray-400'
                }`}></div>
              </div>

              {/* Info */}
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-bold text-gray-800 font-arabic">
                    {passenger.showContact ? passenger.name : passenger.shortName}
                  </h3>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    passenger.isOnline 
                      ? 'bg-green-100 text-green-600' 
                      : 'bg-gray-100 text-gray-600'
                  } font-arabic`}>
                    {passenger.isOnline ? 'متصل' : 'غير متصل'}
                  </span>
                </div>
                
                <p className="text-gray-600 text-sm mb-2 font-arabic">{passenger.bio}</p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2 space-x-reverse text-xs text-gray-500">
                    <span className="font-arabic">{passenger.country}</span>
                    <i className="ri-arrow-left-line"></i>
                    <span className="font-arabic">{passenger.destination}</span>
                  </div>
                  
                  <button
                    onClick={() => handleChatRequest(passenger)}
                    className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:shadow-lg transition-all duration-300 font-arabic"
                  >
                    إرسال طلب
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {filteredPassengers.length === 0 && (
        <div className="text-center py-12">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-group-line text-3xl text-gray-400"></i>
          </div>
          <h3 className="text-lg font-bold text-gray-800 mb-2 font-arabic">لا توجد نتائج</h3>
          <p className="text-gray-600 font-arabic">لم يتم العثور على ركاب بالفلتر المحدد</p>
        </div>
      )}

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-6 py-3">
        <div className="grid grid-cols-4 gap-1">
          <button 
            onClick={() => navigate('/main')}
            className="flex flex-col items-center py-2 text-gray-400"
          >
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center py-2 text-blue-500">
            <i className="ri-group-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الركاب</span>
          </button>
          <button 
            onClick={() => navigate('/chats')}
            className="flex flex-col items-center py-2 text-gray-400"
          >
            <i className="ri-chat-3-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الرسائل</span>
          </button>
          <button 
            onClick={() => navigate('/profile')}
            className="flex flex-col items-center py-2 text-gray-400"
          >
            <i className="ri-user-line text-xl mb-1"></i>
            <span className="text-xs font-arabic">الملف</span>
          </button>
        </div>
      </div>

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
      `}</style>
    </div>
  );
}
